(function($){
  $(function() {
	var navCollapse = $("#main-collapse"),
		sidebarCollapse = $(".sidebar");
  
    // DG - Added JSFiddle code for dropdown menu behaviour here
    $(".dropdown-menu > li > a.trigger").on("click",function(e){
		var current=$(this).next();
		var grandparent=$(this).parent().parent();
		if($(this).hasClass('left-caret')||$(this).hasClass('right-caret'))
			$(this).toggleClass('left-caret right-caret');
		grandparent.find('.left-caret').not(this).toggleClass('right-caret left-caret');
		grandparent.find(".sub-menu:visible").not(current).hide();
		current.toggle();
		e.stopPropagation();
	});
	$(".dropdown-menu > li > a:not(.trigger)").on("click",function(){
		var root=$(this).closest('.dropdown');
		root.find('.left-caret').toggleClass('right-caret left-caret');
		root.find('.sub-menu:visible').hide();
	});
  });

  if( _bilingualTheme.settings.sidebar_default_state == "closed" ){
		$('.parent-menu').removeClass('open');
		$('.child-menu').hide();
  }

  $('.parent-menu').on('click', function(e){
		e.preventDefault();
		var self = $(this);
		self.toggleClass('open');
		self.next().slideToggle();
  });
})(jQuery);